import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Video } from 'lucide-react';
export function TestimonialeFinalCTA() {
  return <section className="py-24 lg:py-32 bg-white relative overflow-hidden" data-id="element-1899">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/[0.07] rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-1900" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-1901" />

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-1902">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-1903">
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-brand-text mb-6 leading-tight text-balance" data-id="element-1904">
            Următoarea poveste poate fi a ta
          </h2>

          <div className="h-[2px] w-16 bg-brand-gold mx-auto rounded-full mb-6" data-id="element-1905" />

          <p className="font-subtitle text-lg md:text-xl text-brand-textSec mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-1906">
            Rezervă o sesiune gratuită de evaluare de 20 de minute și hai să
            vedem împreună care e următorul pas pentru tine.
            <br data-id="element-1907" />
            <span className="text-brand-textSec/80 text-base" data-id="element-1908">
              Online, fără obligații, doar claritate și ghidare.
            </span>
          </p>

          <a href="https://wa.me/40726042604?text=Bun%C4%83.%0A%0ASunt%20interesat%2F%C4%83%20de%20sesiunea%20CADOU%20de%20Claritate%20de%2030%20de%20minute.%0A%0AVreau%20s%C4%83%20aflu%20mai%20multe%20detalii%20despre%20programele%20tale.%0A%0AMul%C8%9Bumesc." target="_top" className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-white font-heading font-bold text-lg md:text-xl px-8 md:px-10 py-5 md:py-6 rounded-2xl hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-1909">
            Rezervă Sesiunea Gratuită de Evaluare
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-1910" />
          </a>

          <div className="mt-8 flex items-center justify-center gap-2 text-brand-textSec text-sm" data-id="element-1911">
            <Video className="w-4 h-4" data-id="element-1912" />
            Sesiunea se desfășoară online, pe Zoom
          </div>
        </motion.div>
      </div>
    </section>;
}